module.exports = __webpack_public_path__ + "img/pariplay.501e4808.svg";